import { Component, input, output } from '@angular/core'

export type Tab<K extends string = string> = Readonly<{ value: K, display: string }>

@Component({
  selector: 'app-page-tabs',
  styles: `
    :host {
        display: flex;
        margin-bottom: 1rem;
    }
  
    .tab {
        height: 37px;
        min-width: 132px;
        font-size: 24px;
        background: none;
        color: #808080;
        border: none;
        border-bottom: 3px solid #e6e6e6;
  
        &.selected {
            color: #218737;
            border-bottom: 3px solid #218737;
        }
    }
  `,
  template: `
    @for(t of tabs(); track t.value) {
      <button class="tab" [class.selected]="t.value === selectedTab()" (click)="selectTab.emit(t.value)">
        {{t.display}}
      </button>
    }
  `,
})
export class PageTabsComponent<K extends string> {
  readonly tabs = input.required<readonly Tab<K>[]>()
  readonly selectedTab = input<K | undefined>()

  readonly selectTab = output<K>()
}
